import React, { useState } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import EditCityComp from '../../components/version-4/MasterForms/EditForms/EditCityComp'
import { useCity } from '../../hooks/CompanyConfiguration/useCity'
import { ROUTES } from '../../shared/constants'

function EditCity() {
  const { city, getCity, updateCity } = useCity()

  const [citydata, setCityData] = useState({
    name: '',
    region: '',
    zone: '',
    state1: '',
    district: '',
    cityCode: '',
    active: '',
  })

  const params = useParams()

  React.useEffect(() => {
    getCity({ cityId: params.cityId })
  }, [params.cityId])

  React.useEffect(() => {
    if (city) {
      setCityData({
        name: city.name,
        region: city.region._id,
        zone: city.zone._id,
        state1: city.state && city.state._id,
        district: city?.district?._id,
        cityCode: city.cityCode,
        active: city.active,
      })
    }
  }, [city])

  const handleCity = () => {
    updateCity({
      name: citydata.name,
      region: citydata.region,
      zone: citydata.zone,
      state: citydata.state1,
      district: citydata.district,
      city: citydata.cityCode,
      cityId: params.cityId,
      cityCode: citydata.cityCode,
      active: citydata.active,
    })
  }
  return (
    <Layout heading="CITY" heading2="Edit" url1={ROUTES.CITY} none>
      {city ? <HeaderTabLayout heading="Edit City" state={citydata} setState={setCityData} content={<EditCityComp state={citydata} setState={setCityData} />} addContent={handleCity} redirect={ROUTES.CITY} /> : <Loader />}
    </Layout>
  )
}

export default EditCity
